





























































































import { Component, Vue } from 'vue-property-decorator';
import {
	Comparer,
	createStringComparer,
	createNumberComparer,
	createDateComparer,
} from '@/utils/Sorting';

import { RecurringPoliciesList } from '@/common/StaffPayments';

// Services
import Staff from '@/services/Staff';

// Components
import Welcome from '@/components/Global/Welcome.vue';
import Loading from '@/components/Global/Loading.vue';
import Alert from '@/components/Global/Alert.vue';
import Search from '@/components/Staff/Payments/Search.vue';

type TableColumn = keyof Pick<
	RecurringPoliciesList,
	'policy_number' | 'policy_status' | 'recurring_enabled' | 'payment_method'
>;

interface TableColumnSortConfig {
	comparer: Comparer<RecurringPoliciesList>;
	descending: boolean;
}

type TableSortConfig = { [P in TableColumn]: TableColumnSortConfig };

@Component({
	name: 'PageStaffAccounting',
	components: {
		Loading,
		Alert,
		Welcome,
		Search,
	},
})
export default class Accounting extends Vue {
	private recurring: RecurringPoliciesList[] = [];
	private filterRecurring: RecurringPoliciesList[] = [];
	private paginate: string[] = ['sortRecurring'];
	private error: boolean = false;
	private loading: boolean = true;
	private paginateKey: string = '';

	private get sortRecurring(): RecurringPoliciesList[] {
		const columnSortConfig: TableColumnSortConfig | undefined = this.sortConfig[
			this.sortColumn
		];
		return this.filterRecurring
			.slice()
			.sort((left: RecurringPoliciesList, right: RecurringPoliciesList): number => {
				const compareResult: number = columnSortConfig.comparer(left, right);
				return columnSortConfig.descending ? -compareResult : compareResult;
			});
	}

	private readonly sortConfig: TableSortConfig = {
		policy_number: {
			comparer: createStringComparer<RecurringPoliciesList, 'policy_number'>('policy_number'),
			descending: true,
		},
		policy_status: {
			comparer: createStringComparer<RecurringPoliciesList, 'policy_status'>('policy_status'),
			descending: false,
		},
		recurring_enabled: {
			comparer: createNumberComparer<RecurringPoliciesList, 'recurring_enabled'>(
				'recurring_enabled',
			),
			descending: false,
		},
		payment_method: {
			comparer: createStringComparer<RecurringPoliciesList, 'payment_method'>(
				'payment_method',
			),
			descending: false,
		},
	};
	private sortColumn: TableColumn = 'policy_number';

	private sortTable(column: TableColumn) {
		if (column !== this.sortColumn) {
			this.sortColumn = column;
		} else {
			this.sortConfig[column].descending = !this.sortConfig[column].descending;
		}
	}

	private getSortIndicatorClasses(column: TableColumn): string {
		return column === this.sortColumn
			? `fas ${this.sortConfig[column].descending ? 'fa-sort-down' : 'fa-sort-up'}`
			: 'd-none';
	}

	private async created() {
		try {
			// Get Users
			const getRecurring = await Staff.getEnabledRecurring();

			if (getRecurring.data.length > 0) {
				this.recurring = getRecurring.data;
				this.filterRecurring = this.recurring;
			}
		} catch (e) {
			this.error = true;
		} finally {
			this.loading = false;
		}
	}
}
